import Ru from '../../lang/ru/site.json';
import En from '../../lang/en/site.json';
import Ua from '../../lang/ua/site.json';

let langs = {
    ru: Ru,
    en: En,
    ua: Ua,
    uk: Ua,
};

function l(index) {
    let activeLang = document.documentElement.lang || 'ru',
        lang = langs[activeLang],
        str;

    if (index === undefined) {
        return activeLang;
    }

    str = lang[index];

    if (typeof str === 'undefined' || str === null || $.trim(str.toString()) === '') {
        if (window.location.host === 'dev.pos') {
            str = '(!) ' + index;
        } else {
            str = index;
        }
    }

    if (arguments.length > 1) {
        if (typeof arguments[1] === 'object') {
            _.each(arguments[1], function (val, key) {
                str = str.replace('%' + key, val);
            });
        } else {
            for (var i = 1; i < arguments.length; i++) {
                str = str.replace('%s', arguments[i]);
            }
        }
    }

    return str;
}

module.exports = l;



// WEBPACK FOOTER //
// ./resources/js/site/lang.js